/* src/app/global/components/global-help/global-help-modules/global-help-modules.component.scss */
.globalHelpModulesGrid,
cw-module-card {
  width: 100%;
}
/*# sourceMappingURL=global-help-modules.component.css.map */
